module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-right-bottom-metals.0dc3fe62.png";